import merge from 'lodash/merge';
import { Dimensions, StyleSheet } from 'react-native';
import { DISTANT, TRANSPARENT, WHITE, dropdownConfig, tokens } from '../../constants';
import { checkIsPlatform, fitContentWidth } from '../../utils';
import { Children } from 'react';
var HEIGHT = Dimensions.get('window').height;
export var getDropDownPosition = (props, layoutRef) => {
  var _a, _b;
  var spacing = tokens.spacing;
  var position = props.position,
    label = props.label,
    children = props.children;
  var yAxisSpacing = (label === null || label === void 0 ? void 0 : label.length) > 0 ? spacing.SPACING_64 : spacing.SPACING_44;
  var result = {
    top: yAxisSpacing
  };
  if (position === 'auto' && checkIsPlatform('web')) {
    var screenThreshold = HEIGHT * 0.6;
    var dropdownPositionFromTop = ((_b = (_a = layoutRef === null || layoutRef === void 0 ? void 0 : layoutRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top) || 0;
    if (dropdownPositionFromTop > screenThreshold) {
      result = {
        bottom: yAxisSpacing
      };
    } else {
      result = {
        top: yAxisSpacing
      };
    }
  } else {
    var dropdownPosition = position === 'above' ? 'bottom' : 'top';
    result = {
      [dropdownPosition]: yAxisSpacing
    };
  }
  if (Children.count(children) > 0) result = {
    top: '120%'
  };
  return result;
};
export var getDropdownComponentStyles = (_state, props, parentType, showDropdownMenu) => {
  var _a, _b;
  var theme = props.theme,
    variant = props.variant,
    variantPosition = props.variantPosition,
    listMaxHeightPercentage = props.listMaxHeightPercentage;
  var spacing = tokens.spacing;
  var windowHeight = Dimensions.get('window').height;
  var _listMaxHeight = listMaxHeightPercentage < 100 && listMaxHeightPercentage > 0 ? listMaxHeightPercentage : 80;
  var _height = _listMaxHeight ? windowHeight * _listMaxHeight / 100 : windowHeight / 2;
  var _ref = props || {},
    configProps = _ref.config;
  var bgColor = (_b = (_a = configProps === null || configProps === void 0 ? void 0 : configProps.controlState) === null || _a === void 0 ? void 0 : _a[_state]) === null || _b === void 0 ? void 0 : _b.backgroundColor;
  var borderColor = configProps === null || configProps === void 0 ? void 0 : configProps.dropdownMenuBorderColor;
  var dropdownParentContainerStyles = Object.assign({}, parentType === 'icon' && Object.assign({
    position: 'relative'
  }, fitContentWidth()));
  var dropdownContainerStyles = Object.assign(Object.assign(Object.assign({}, parentType === 'input' && {
    maxHeight: _height
  }), parentType !== 'input' && {
    top: spacing.SPACING_32
  }), parentType === 'icon' && {
    left: undefined,
    right: 0
  });
  return StyleSheet.create({
    dropdownParentContainer: Object.assign({
      zIndex: showDropdownMenu ? 9999 : 0,
      backgroundColor: TRANSPARENT,
      maxHeight: _height
    }, dropdownParentContainerStyles),
    dropdownContainer: Object.assign(Object.assign(Object.assign(Object.assign({}, showDropdownMenu && {
      zIndex: 101
    }), {
      position: 'absolute',
      left: -1,
      right: -1,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_16,
      borderWidth: 1,
      borderColor,
      backgroundColor: WHITE,
      zIndex: 100
    }), dropdownContainerStyles), theme !== 'white' && Object.assign({}, DISTANT)),
    dropdownMenuContainer: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: spacing.SPACING_16,
      paddingVertical: spacing.SPACING_8,
      backgroundColor: bgColor
    },
    titleSection: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingHorizontal: spacing.SPACING_16,
      paddingVertical: spacing.SPACING_8
    },
    dropdownMenuInfo: {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 1
    },
    dropdownMenuInfoItem: Object.assign(Object.assign(Object.assign({
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1
    }, (parentType === 'icon' || variant === 'none' || (props === null || props === void 0 ? void 0 : props.showChildDropDown)) && {
      width: '100%'
    }), variantPosition === 'right' && variant === 'none' && {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }), variantPosition === 'right' && (variant === 'radio' || variant === 'checkbox') && {
      flexDirection: 'row-reverse',
      alignItems: 'center',
      justifyContent: 'space-between',
      flex: 1
    }),
    variantContainer: Object.assign({
      marginRight: spacing.SPACING_12
    }, (parentType === 'icon' || variant === 'none' || (props === null || props === void 0 ? void 0 : props.showChildDropDown)) && {
      flex: 1
    }),
    headingSubheadingContainer: {
      flexDirection: 'column',
      flex: 1
    },
    outerBtnForOutsideClick: {
      backgroundColor: TRANSPARENT,
      position: 'absolute',
      zIndex: 100,
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      height: windowHeight,
      width: Dimensions.get('window').width
    },
    noDataContainer: {
      paddingHorizontal: spacing === null || spacing === void 0 ? void 0 : spacing.SPACING_8,
      paddingVertical: spacing === null || spacing === void 0 ? void 0 : spacing.SPACING_16,
      alignItems: 'center'
    }
  });
};
export var getDropdownStyles = () => {
  return StyleSheet.create({
    dropdownBody: {
      flexDirection: 'row',
      flex: 1,
      alignItems: 'flex-end'
    },
    dropDown: {
      flex: 0.4
    },
    dropdownContainer: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    childStyle: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    },
    childContainerStyle: {
      flex: 0.6
    }
  });
};
export var setRightAvatarStyles = (item, variant, variantPosition) => {
  var _a;
  if (variant === 'avatar' && variantPosition === 'right' && (item === null || item === void 0 ? void 0 : item.avatarData) && ((_a = item === null || item === void 0 ? void 0 : item.avatarData) === null || _a === void 0 ? void 0 : _a.iconName)) {
    return {
      flexDirection: 'row-reverse',
      flex: 1,
      justifyContent: 'space-between'
    };
  }
  return {};
};
export var getDropdownProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(dropdownConfig === null || dropdownConfig === void 0 ? void 0 : dropdownConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.dropdown) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};